// import { Column } from 'react-table'
// import { columnGenerators } from '../../../../../../_metronic/helpers'

// const header = (isPartner = false, isSupplyChainManager = false, isFacilityManager) => [
//   { label: 'S.N', value: 'id' },
//   {
//     label: 'Business name',
//     value: 'name',
//   },
//   /* {
//     label: 'Birthday',
//     value: 'birthday',
//   },
//   {
//     label: 'Gender',
//     value: 'gender',
//   },*/
//   /* {
//     label: 'Email Address',
//     value: 'email',
//   }, */
//   {
//     // label: isSupplyChainManager ? 'Supply chain' : 'Franchise',
//     label: isFacilityManager || isSupplyChainManager ? 'Supply chain' : 'Franchise',
//     value: 'franchiseName',
//   },
//   // {
//   //   label: 'Factory Type',
//   //   value: 'facilityType',
//   // },
//   {
//     label: 'Hub type',
//     value: 'facilityType',
//   },
//   {
//     label: 'Country',
//     value: 'address[country]',
//   },
//   {
//     label: 'City',
//     value: 'address[city]',
//   },
//   {
//     label: 'Manager',
//     value: 'facilityManagers',
//   },
//   {
//     label: 'App user',
//     value: 'facilityStaff',
//   },
//   {
//     label: 'status',
//     value: 'statusUi',
//   },
//   // ...((!isPartner && [{action: ['edit']}]) || []),


//   // ...((!isPartner && !isFacilityManager && [{ action: ['edit'] }]) || []),
//   ...((!isPartner && !isFacilityManager && [{ action: ['edit', 'details'] }]) || []),


//   // {
//   //   action: ['edit'],
//   // },
// ]


// // ['edit', 'details'] 

// const roleColumns = (isPartner = false, isSupplyChainManager = false, isFacilityManager) => {
//   return columnGenerators(header(isPartner, isSupplyChainManager, isFacilityManager))
// }
// export { roleColumns }

// // const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

// // export {roleColumns}






import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = (isPartner = false, isSupplyChainManager = false, isFacilityManager = false, isMarketingUser = false) => [
  { label: 'S.N', value: 'id' },
  {
    label: 'Hub name',
    value: 'hubUserName',
  },
  {
    label: isFacilityManager || isSupplyChainManager ? 'Supply chain' : 'Supply chain',
    value: 'franchiseName',
  },
  {
    label: 'Hub type',
    value: 'facilityType',
  },
  {
    label: 'Country',
    value: 'address[country]',
  },
  {
    label: 'City',
    value: 'address[city]',
  },
  {
    label: 'Manager',
    value: 'facilityManagers',
  },
  {
    label: 'App user',
    value: 'facilityStaff',
  },
  {
    label: 'status',
    value: 'statusUi',
  },
  ...((!isPartner && !isFacilityManager && [{ action: isMarketingUser ? ['details'] : ['edit', 'details'] }]) || []),
]

const roleColumns = (isPartner = false, isSupplyChainManager = false, isFacilityManager = false, isMarketingUser = false) => {
  return columnGenerators(header(isPartner, isSupplyChainManager, isFacilityManager, isMarketingUser))
}

export { roleColumns }